module.exports = __webpack_public_path__ + "img/tab1.6923e3ce.png";